angular.module('capability-ng-scheduler').factory('LocationBuilder', function LocationBuilder(Interface) {
  var DTD = {
    id: 'key',
    campus: 'integer',
    name: 'string',
    address: 'string',
    comments: 'string',
    latittude: 'number',
    longitude: 'number',
    _campus: 'object'
  };

  function LocationDTO(data) {
    Interface.implement(DTD, data, this);
  }

  return LocationDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/location_builder.es.js